/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

import { OverlayCloseEvent } from '@shared/components/overlay/custom-overlay-ref';

export enum QuarterCloseChecklistRowPermissionFields {
  'Confirm Discounts' = 'userHasChecklistDiscountsPermission',
  'Confirm Investigator Data' = 'userHasChecklistPatientDataPermission',
  // ConfirmForecast
  'Confirm Trial Timeline' = 'userHasChecklistTrialTimelinePermission',
  // ConfirmClose
  'Confirm Vendor Expenses' = 'userHasChecklistVendorExpensesPermission',
  'Forecast Methodology' = 'userHasChecklistForecastMethodologyPermission',
  // GatherDocuments
  'Pending Change Orders, Purchase Orders, New Vendor Contracts, or Vendor Budgets' = 'userHasChecklistContractsPermission',
  'Review Invoices' = 'userHasChecklistInvoicesPermission',
  'Review Vendor Estimates' = 'userHasChecklistVendorEstimatesPermission',
  'Site, Patient, & Custom Curves' = 'userHasChecklistPatientSiteCurvePermission',
}

export enum QuarterCloseChecklistRowSections {
  // CloseMonth
  'Close Month' = 'CloseMonth',
  'Confirm Discounts' = 'ConfirmClose',
  'Confirm Investigator Data' = 'GatherDocuments',
  // ConfirmForecast
  'Confirm Trial Timeline' = 'ConfirmForecast',
  // ConfirmClose
  'Confirm Vendor Expenses' = 'ConfirmClose',
  'Forecast Methodology' = 'ConfirmForecast',
  // GatherDocuments
  'Pending Change Orders, Purchase Orders, New Vendor Contracts, or Vendor Budgets' = 'GatherDocuments',
  'Review Invoices' = 'GatherDocuments',
  'Review Vendor Estimates' = 'GatherDocuments',
  'Site, Patient, & Custom Curves' = 'ConfirmForecast',
}

export enum QuarterCloseChecklistRowTitles {
  CloseDiscounts = 'Confirm Discounts',
  // ConfirmClose
  CloseExpenses = 'Confirm Vendor Expenses',
  //
  CloseMonth = 'Close Month',
  ForecastCurves = 'Site, Patient, & Custom Curves',
  ForecastMethodology = 'Forecast Methodology',
  // ConfirmForecast
  ForecastTimeline = 'Confirm Trial Timeline',
  // GatherDocuments
  GatherContracts = 'Pending Change Orders, Purchase Orders, New Vendor Contracts, or Vendor Budgets',
  GatherEstimates = 'Review Vendor Estimates',
  GatherInvoices = 'Review Invoices, Prepaids, and Credit Memos',
  GatherPatients = 'Confirm Investigator Data',
}

export type ShowWarningModalResponse = Promise<OverlayCloseEvent<boolean>>;
